import { NoteIcon } from "components/Icons";
import { cn } from "tools/ui";
import { useNotesModal } from "components/Meta/notesModalStore";

function NotesCell({ field, attrs, record }) {
  const notes = record?.["notes."] ?? [];
  const hasUnread =
    notes.some((note) => note.unread === true) ?? false;

  function openModal(e) {
    e.stopPropagation();
    useNotesModal
      .getState()
      .openModal(record, null, `${attrs.model}.notifications`);
  }

  if (!attrs.isVisible) return null;

  return (
    <button
      onClick={openModal}
      className={cn(
        "relative mx-auto flex items-center justify-center rounded-md p-1 active:scale-90 transition-all duration-200",
        hasUnread ? "text-amber-500" : "text-gray-400 hover:text-gray-600",
      )}
      aria-label={field.name}
    >
      <NoteIcon className="h-6 w-6 fill-current text-cyan-500 active:text-cyan-700" />
      {notes.length > 0 && (
        <span
          className={cn(
            "absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-semibold text-white",
            hasUnread ? "bg-amber-500" : "bg-gray-400",
          )}
        >
          {notes.length}
        </span>
      )}
    </button>
  );
}

export default NotesCell;
